import { FC, ButtonHTMLAttributes } from 'react';
import Button from '../Button/Button';
import Icon from '../Icon/Icon';
import './MenuItem.css';
interface MenuItemProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    isSelected?: boolean;
    icon?: keyof Omit<typeof import('lucide-react'), 'createLucideIcon'>;
    iconPosition?: 'left' | 'right';
}

const MenuItem: FC<MenuItemProps> = ({ 
  children, 
  className = '', 
  icon,
  iconPosition = 'left',
  isSelected = false,
  ...props 
}) => {
  return (
    <Button
      className={`menu-item ${isSelected ? 'selected' : ''} ${className}`}
      {...props}
    >
      {icon && iconPosition === 'left' && (
        <Icon name={icon} className="menu-item__icon menu-item__icon--left" />
      )}
      {children}
      {icon && iconPosition === 'right' && (
        <Icon name={icon} className="menu-item__icon menu-item__icon--right" />
      )}
    </Button>
  );
};

export default MenuItem; 
